const copy = input => {
    input.type = 'text';
    input.select();
    document.execCommand( 'copy' );
    input.type = 'hidden';
};

export default copy;